import *  as React from 'react';
import { useAtom, atom } from 'jotai';

const cabRangePart = "Porter";
const cabColourPart = "White";
const HandleShapePart = "Edge";
const BackplatePart = "Carbon";
const worksurfaceImg = 'Absolute_Marbled';

export const imgMove = atom(false);

export const sceneAtom = atom<{ [index: string]: string | string[] }>({
    "Door Range": [cabRangePart],
    "Door Colour": [cabColourPart],
    "Handle Shape": [HandleShapePart],
    "Backplate Finish": [BackplatePart],
    "Worksurface": [worksurfaceImg],
}); 

export const currentUrl = atom({
    cabRange: '',      /*cr1*/
    cabCol: '',        /*cc1*/
    handleShape: '',   /*hs1*/

    backplate: '',     /*bp1*/
    worksurface: '',   /*ws1*/
});

export const selectedName = atom(["Porter", "White", "Edge", "Carbon", "Absolute Marbled"])